import { render, staticRenderFns } from "./topCenter.vue?vue&type=template&id=6558c881&scoped=true&"
import script from "./topCenter.vue?vue&type=script&lang=js&"
export * from "./topCenter.vue?vue&type=script&lang=js&"
import style0 from "./topCenter.vue?vue&type=style&index=0&id=6558c881&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6558c881",
  null
  
)

export default component.exports